import { VehicleFinderFormComponent } from 'components/driving/vehicle-finder-form/vehicle-finder-form.component'
export default VehicleFinderFormComponent
